var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-row",
        { attrs: { align: "center" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("v-autocomplete", {
                attrs: {
                  outlined: "",
                  multiple: "",
                  "hide-details": "",
                  "return-object": "",
                  dense: "",
                  chips: "",
                  "item-value": "id",
                  "item-text": "title",
                  "no-data-text": "Список пуст",
                  placeholder: "Начните вводить для поиска...",
                  items: _vm.chosenItems,
                  value: _vm.listItem.data.where.id,
                  disabled: _vm.isQueriesLoading,
                  loading: _vm.isQueriesLoading,
                  "search-input": _vm.search,
                },
                on: {
                  "update:searchInput": function ($event) {
                    _vm.search = $event
                  },
                  "update:search-input": function ($event) {
                    _vm.search = $event
                  },
                  change: _vm.updateValueHandler,
                },
                scopedSlots: _vm._u([
                  {
                    key: "item",
                    fn: function (data) {
                      return [
                        _c(
                          "v-col",
                          [
                            _c("v-list-item-title", [
                              _vm._v(_vm._s(data.item.title)),
                            ]),
                            data.item.type === "EVENT"
                              ? _c("v-list-item-subtitle", [
                                  _vm._v(" Событие "),
                                ])
                              : _vm._e(),
                            data.item.type === "PLACE"
                              ? _c("v-list-item-subtitle", [_vm._v(" Место ")])
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                  {
                    key: "selection",
                    fn: function (data) {
                      return [
                        _c(
                          "draggable",
                          _vm._b(
                            {
                              attrs: {
                                id: data.index,
                                list: _vm.listItem.data.where.id,
                                move: _vm.move,
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.change({
                                    value: $event,
                                    dragged: _vm.dragged,
                                  })
                                },
                              },
                            },
                            "draggable",
                            _vm.dragOptionsChips,
                            false
                          ),
                          [
                            _c(
                              "v-chip",
                              {
                                key: data.item.id,
                                attrs: {
                                  draggable: "",
                                  label: "",
                                  value: _vm.listItem.data.where.id[data.index],
                                },
                                on: {
                                  mousedown: function ($event) {
                                    $event.stopPropagation()
                                  },
                                  click: function ($event) {
                                    $event.stopPropagation()
                                  },
                                },
                              },
                              [_vm._v(" " + _vm._s(data.item.title) + " ")]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }